module.exports = kolibriGlobal.coreVue.mixins.contentRendererMixin;